<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 16 14">
    <path d="M2 12h6v-4h-6v4zM10 8h4v-6h-6v2h0.75c0.688 0 1.25 0.563 1.25 1.25v2.75zM16 1.25v7.5c0 0.688-0.563 1.25-1.25 1.25h-4.75v2.75c0 0.688-0.563 1.25-1.25 1.25h-7.5c-0.688 0-1.25-0.563-1.25-1.25v-7.5c0-0.688 0.563-1.25 1.25-1.25h4.75v-2.75c0-0.688 0.563-1.25 1.25-1.25h7.5c0.688 0 1.25 0.563 1.25 1.25z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-window-restore.html